import React, { useState } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { templateParser, formatUnitString } from 'utils/formatString';
import { accumulatorTypes, printKbytes, printSeconds } from 'utils/accumulators';

import { Heading, Button, HTML } from 'components';
import withServiceConnection from 'pages/Home/containers/YouthTariff/hocs/withServiceConnection';
import ConnectionService from '../../../ConnectionService';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

const printAccFns = {
  KBYTE: printKbytes,
  SECOND: printSeconds,
  SECONDS: printSeconds,
  SMS: (r) => formatUnitString(r, accumulatorTypes.sms),
};

const ServiceForm = (props) => {
  const {
    content,
    service,
    accumulators,
    onClose,
    onSuccess,
    onSetPending,

    initServiceConnection,
    connectionContent,
  } = props;
  const { serviceType, price } = service;
  const descriptionData = content.descriptions[serviceType.toLowerCase()];
  const [isShowConnectionService, setIsShowConnectionService] = useState(false);
  const acc = accumulators.listForYoung
    .find(({ unit }) => (descriptionData ? unit === descriptionData.restPackageUnit : false));

  const onConnectClick = () => {
    initServiceConnection(
      '/customers/products/mobile/services/getserviceconfirmationpopup/',
      {
        soc: service.soc,
        name: service.name,
        ignoreConflictSocs: service.ignoreConflictSocs,
      },
    );
    setIsShowConnectionService(true);
  };

  if (isShowConnectionService) {
    return (
      <ConnectionService
        onSuccess={onSuccess}
        onSetPending={onSetPending}

        onTimeoutBtnClick={onClose}
        onErrorBtnClick={onClose}
        content={connectionContent}
        serviceName={service.name}
        serviceSoc={service.soc}
      />
    );
  }

  return (
    <div className={cx('wrapper')}>
      <Heading level={1} isStyled={false}>
        {service.name}
      </Heading>
      <HTML as="div" className={cx('formDescription')}>
        {templateParser(descriptionData?.text, { price })}
        {acc?.rest > 0 && (
          templateParser(descriptionData?.restPackage, {
            accRest: printAccFns[acc.unit]?.(acc.rest) ?? acc.rest,
          })
        )}
      </HTML>
      <div className={cx('btnWrap')}>
        <Button
          type="button"
          className="big"
          onClick={onConnectClick}
          wide
        >
          {content.connectBtn}
        </Button>
      </div>
    </div>
  );
};

ServiceForm.propTypes = {
  connectionContent: PropTypes.object,
  content: PropTypes.shape({
    connectBtn: PropTypes.string,
    connectionWait: PropTypes.string,
    errorData: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      btn: PropTypes.string,
    }),
    timeoutData: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      btn: PropTypes.string,
    }),
    descriptions: PropTypes.objectOf(PropTypes.string),
  }),
  service: PropTypes.shape({
    soc: PropTypes.string,
    name: PropTypes.string,
    serviceType: PropTypes.string,
    price: PropTypes.string,
    ignoreConflictSocs: PropTypes.arrayOf(PropTypes.string),
  }),
  accumulators: PropTypes.shape({
    listForYoung: PropTypes.arrayOf(PropTypes.shape({
      unit: PropTypes.string,
      rest: PropTypes.number,
    })),
  }),
  serviceConnectionPopup: PropTypes.shape({
    data: PropTypes.shape({
      serviceConnectForm: PropTypes.shape({
        warningText: PropTypes.string,
      }),
    }),
    resultPopupData: PropTypes.shape({
      connectionStatus: PropTypes.number,
    }),
    serviceProcess: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  onSetPending: PropTypes.func,
  initServiceConnection: PropTypes.func,
};

export default withServiceConnection(ServiceForm);
